import { useLanguage } from "@/context/AppContext";

export default function Hero() {
  const { t } = useLanguage();
  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-overlay" />
      <div className="hero-copy">
        <p className="eyebrow" data-testid="hero-eyebrow">{t.hero.eyebrow}</p>
        <h1 data-testid="hero-title">
          {t.hero.l1}
          <br />
          {t.hero.l2}
        </h1>
        <p className="hero-text" data-testid="hero-tagline">{t.hero.text}</p>
        <a className="btn primary" href="#story" data-testid="hero-explore-button">
          {t.hero.cta}
        </a>
      </div>
      <div className="hero-note" data-testid="hero-note">
        <span>{t.hero.noteBig}</span>
        <small>
          {t.hero.noteA}
          <br />
          {t.hero.noteB}
        </small>
      </div>
    </section>
  );
}
